import { SvgIcon, SvgIconProps } from '@mui/material'

export const DaycareIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} data-testid="DaycareIcon">
      <path
        d="M12.3984 22.4004V19.4077M12.3984 5.39309V2.40039M2.39844 12.4004H5.39114M19.4057 12.4004H22.3984M5.34248 19.4564L7.45927 17.3396M17.3376 7.46122L19.4544 5.34443M5.34248 5.34443L7.45927 7.46122M17.3376 17.3396L19.4544 19.4564"
        stroke={props.fill || 'white'}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        fill={props.fill}
        d="M12.4236 17.4009C15.1708 17.4009 17.3979 15.1738 17.3979 12.4265C17.3979 9.67924 15.1708 7.45215 12.4236 7.45215C9.67631 7.45215 7.44922 9.67924 7.44922 12.4265C7.44922 15.1738 9.67631 17.4009 12.4236 17.4009Z"
      />
    </SvgIcon>
  )
}
